export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/report-stars.1be32593.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};